import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { CustomSelection, Report, RowActions, SelectionAction } from '../../report';
import { AdvancedSalesCancelRequestService } from '../../services/advanced-sales-cancel-request.service';
import { AdvancedSalesReportService } from './advanced-sales-report.service';
import { AdvancedSalesStatusService } from './advanced-sales-status.service';
import moment from 'moment';
import { ADVANCE_SALES_STATUS } from 'src/app/shared/services/advanceSalesStatus';

@Component({
  selector: 'app-advanced-sales',
  templateUrl: './advanced-sales.component.html',
  styleUrls: ['./advanced-sales.component.scss']
})

export class AdvancedSalesComponent implements OnInit {
  salesReportData: any[] = [];
  tableColumns: string[] = [
    'businessName',
    'status',
    'createdAt',
    'startDate',
    'fees',
    'principleAmount',
    'totalAmount',
    'paidAmount',
    'isEnabled',
    'salesLimit',
    'canCancel'
  ];
  displayTableColumns = {
    'businessName': 'Business Name',
    'status': 'Status',
    'createdAt': 'Created At',
    'startDate': 'Start Date',
    'fees': 'Fees',
    'principleAmount': 'Principle Amount',
    'totalAmount': 'Total Amount',
    'paidAmount': 'Paid Amount',
    'isEnabled': 'Enabled/Disabled',
    'salesLimit': 'Limit',
    'canCancel': 'Cancel'
  };
  rowActions: RowActions[] = [
    {
      actionName: "Edit",
      actionType: "icon",
      iconClass: "fa-edit"
    }
  ];
  selectionActions: SelectionAction[] = [
    {
      actionName: "Accept",
      actionValue: "running",
      actionType: "Button",
      actionClass: "btn-success"
    },
    {
      actionName: "Reject",
      actionValue: "cancelled",
      actionType: "Button",
      actionClass: "btn-outline-danger"
    }
  ];
  selectableRows: CustomSelection[] = [
    {
      colName: "status",
      valueIn: ["pending"]
    }
  ];
  filterField = [
    {
      filterFieldName: "status",
      filterDisplayName: "Advance Sales Status",
      defaultValue: ADVANCE_SALES_STATUS.PENDING,
      filterOptions: [
        { key: "Show All", value: null },
        { key: ADVANCE_SALES_STATUS.RUNNING, value: ADVANCE_SALES_STATUS.RUNNING },
        { key: ADVANCE_SALES_STATUS.CANCELLED, value: ADVANCE_SALES_STATUS.CANCELLED },
        { key: ADVANCE_SALES_STATUS.PENDING, value: ADVANCE_SALES_STATUS.PENDING },
      ]
    }
  ];

  totalNumberOfRecords = 0;
  requestBody: Report = {};
  loading = false;
  selectionModel = new SelectionModel<any>(true, []);

  constructor(public advanced_salesService: AdvancedSalesReportService, private updateSalesRequest: AdvancedSalesStatusService,
    private advancedSalesCancelRequestService: AdvancedSalesCancelRequestService) { }

  ngOnInit(): void {
    this.advanced_salesService.activateLoader();
    this.requestBody.filterOptions={status: ADVANCE_SALES_STATUS.PENDING};
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async updateTable() {
    this.advanced_salesService.activateLoader();
    this.advanced_salesService.setParams(this.requestBody);
    const report = await this.advanced_salesService.make();
    report.result.forEach((r: any) => {
      r.startDate != null ? r.startDate = moment(r.startDate).format('LL') : '';
      r.createdAt = moment(r.createdAt).format('LL');
      r.isEnabled == false ? r.isEnabled = 'Disabled' : r.isEnabled = 'Enabled'
    });
    this.salesReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.advanced_salesService.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.advanced_salesService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = undefined;
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.advanced_salesService.loader().subscribe(val => (this.loading = val));
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.advanced_salesService.loader().subscribe(val => (this.loading = val));
  }

  async selectionActionsCB(event: any) {
    try {
      let requests: any[] = event.selection
      let ids: any[] = []
      let ignoredIds: any[] = []
      for (const req of requests) {
        if (req.isEnabled != "Disabled") {
          ids.push(req.id)
        } else {
          ignoredIds.push(req)
        }
      }
      const status = event.action
      await this.handleRequests(status, ids);
      this.refusedIds(ignoredIds);
    } catch (err) {
      console.log(err);
    }
  }

  async handleRequests(status: string, ids: any[]) {
    this.updateSalesRequest.setParams({ status, ids })
    await this.updateSalesRequest.make();
    this.updateTable();
    this.advanced_salesService.loader().subscribe(val => (this.loading = val));
  }

  refusedIds(ids: any[]) {
    if (!ids.length) return
    Swal.fire({
      icon: 'warning',
      title: 'You have chosen a disabled business request',
      text: 'Please make sure that you chosed an Enable business!',
    })
  }

  async changeAmountOfRequestAndAccept(amount: any, request: any, status: any) {
    if (amount == null || amount > Number(request.principleAmount)) {
      return { message: 'Please enter a valid amount', title: 'Failed', status: 'error' }
    } else {
      this.updateSalesRequest.setParams({ status, ids: [request.id], newAmount: amount })
      await this.updateSalesRequest.make();
      this.updateTable();
      this.advanced_salesService.loader().subscribe(val => (this.loading = val));
      return { message: 'Request has been updated', title: 'Success', status: 'success' }
    }
  }

  rowActionClicked(event: any) {
    const request = event.key
    if (request.status != 'pending') return
    Swal.fire({
      title: 'Select a new amount',
      input: 'number',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      preConfirm: async (amount) => {
        let result = await this.changeAmountOfRequestAndAccept(amount, request, 'running');
        return result
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result: any) => {
      this.showAlert(result.value.message, result.value.title, result.value.status)
    })
  }

  showAlert(message: any, title: any, status: any) {
    Swal.fire({
      icon: status,
      title: `${title}`,
      text: `${message}`,
    })
  }

  public async cancelAdvancedSalesRequest(requestID: any) {
    this.advancedSalesCancelRequestService.setParams({ "id": requestID });
    await this.advancedSalesCancelRequestService.make();
    this.ngOnInit();
  }
}

